import moment from 'moment';

  export const getDaysInRange = (from, to) => {
        const daysArray = [];
    
        const startDate = moment(from, 'DD/MM/YY');
        const endDate = moment(to, 'DD/MM/YY');
      
        if (startDate.isSame(endDate, 'day')) {
          daysArray.push(startDate.day()); 
        } else {
          let currentDate = startDate;
      
          while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
            daysArray.push(currentDate.day()); 
            currentDate = currentDate.add(1, 'days'); 
          }
      
          if (daysArray.length > 7) {
            daysArray.splice(7); 
          }
        }
      
        return daysArray;
      };